import React from 'react'

export type ChevronDownIconProps = {
  color?: string
  className?: string
  width?: number
  height?: number
}

export const ChevronDownIcon = ({
  color = 'currentColor',
  className,
  width = 24,
  height = 24,
}: ChevronDownIconProps) => (
  <svg
    aria-label='Chevron down'
    className={className}
    fill='none'
    height={height}
    role='img'
    viewBox='0 0 24 24'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M19 8L12 16L5 8' stroke={color} strokeWidth='2' />
  </svg>
)
